import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontWeights,
  palette,
}: Theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1.5rem 1rem',
    color: palette.text.primary,
  },
  confirmation: {
    display: 'block',
    width: '100%',
    maxWidth: '20.5rem',
    margin: '0 auto',
    [breakpoints.up('md')]: {
      width: '100%',
      maxWidth: '34.25rem',
    },
  },
  confirmationImage: {
    width: '100%',
    height: 'auto',
    margin: 0,
  },
  download: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '0.5rem',
    textAlign: 'center',
    '& h1': {
      margin: 0,
      fontSize: '1rem',
      lineHeight: 1.5,
      fontWeight: fontWeights.regular,
      whiteSpace: 'pre-line',
    },
  },
  storeLinks: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    width: '16.75rem',
    margin: '1rem 0 0',
    padding: 0,
    listStyle: 'none',
    '& li': {
      width: '100%',
    },
    '& a': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '16.75rem',
      height: '3.5rem',
      padding: '1rem 0.25rem',
      border: `0.125rem solid ${palette.custom.appStoreBorder}`,
      borderRadius: '2.875rem',
      background: palette.common.white,
    },
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      width: '34.25rem',
      '& li': {
        flex: '1 1 0',
      },
      '& a': {
        padding: '1.25rem',
      },
    },
  },
  storeIcon: {
    display: 'block',
    width: '100%',
    maxWidth: '8.45rem',
    height: 'auto',
    margin: '0 auto',
  },
  qrPanel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    width: '20.5rem',
    marginTop: '2rem',
    padding: '1.25rem 1rem 1rem',
    borderRadius: '2rem',
    background: 'linear-gradient(139.4deg, #0087D5 28.92%, #C873F7 108.22%)',
    color: palette.common.white,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      width: '34.25rem',
      padding: '1rem',
    },
  },
  qrCopy: {
    flex: '1 1 auto',
    padding: '0 0.5rem',
    [breakpoints.up('md')]: {
      padding: '0 0 0 0.375rem',
    },
    '& h2': {
      margin: 0,
      fontSize: '1.25rem',
      lineHeight: 1.3,
      fontWeight: fontWeights.medium,
      color: palette.common.white,
    },
    '& p': {
      margin: '0.625rem 0 0',
      fontSize: '1rem',
      lineHeight: 1.5,
      color: palette.common.white,
    },
  },
  qrImage: {
    display: 'block',
    flexShrink: 0,
    width: '12.5rem',
    height: '12.5rem',
    borderRadius: '0.85rem',
    background: palette.common.white,
  },
  veeva: {
    margin: '1rem 0 0',
    fontSize: '0.75rem',
    lineHeight: 1,
    color: palette.custom.veevaText,
    '& > div': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      color: 'inherit',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  block: {
    display: 'block',
  },
}));
